// extracted by mini-css-extract-plugin
module.exports = {"phoneInput":"_f5d2a9d"};